module.exports = __webpack_public_path__ + "img/img_2.413054c8.png";